import React, { useState, useEffect } from "react";

import { Switch, Route, Redirect, useLocation } from "react-router-dom";

import ProtectedLayout from "./layouts/protected";
import PublicLayout from "./layouts/public";

import Auth from "@aws-amplify/auth";
import jwt_decode from "jwt-decode";

// import Login from "~/pages/Login";

// import { AmplifyTheme } from "aws-amplify-react";
// import { withAuthenticator } from '@aws-amplify/ui-react'
// import Loader from "./components/Loader";

function Router() {
  const publicRoutes = ["/login", "/forgot-password"];
  const location = useLocation();

  // const [isAuthenticated, setIsAuthenticated] = useState(true);                  // @TODO: UNCOMMENT to work locally
  const [isAuthenticated, setIsAuthenticated] = useState(null);                     // @TODO: COMMENT to work locally
  const [user, setUser] = useState();
  const [roles, setRoles] = useState();

  useEffect(() => {
    async function signUp() {                                                       // @TODO: COMMENT to work locally
      try {                                                                         // @TODO: COMMENT to work locally
        const session = await Auth.currentSession();                                // @TODO: COMMENT to work locally
        const decodedToken = jwt_decode(session.idToken.jwtToken);                  // @TODO: COMMENT to work locally

        // setUser("Test")                                                          // @TODO: UNCOMMENT to work locally
        setUser(decodedToken["cognito:username"]);                                  // @TODO: COMMENT to work locally

        setRoles(["admin"]); // todo: replace this
        // We've hardcoded the role to admin, while we wait for Azure AD to
        // provide multiple groups

        // if (typeof decodedToken["cognito:groups"] == "undefined") {
        //   setRoles(["client"]);
        // } else {
        //   setRoles(decodedToken["cognito:groups"]);
        // }

        setIsAuthenticated(true);
      } catch (error) {                                                             // @TODO: COMMENT to work locally
        setIsAuthenticated(false);                                                  // @TODO: COMMENT to work locally
      }                                                                             // @TODO: COMMENT to work locally
    }                                                                               // @TODO: COMMENT to work locally

    signUp();                                                                       // @TODO: COMMENT to work locally
  }, [location]);

  return (
    <Switch>
      <Route path={publicRoutes} component={PublicLayout} />
      {isAuthenticated && (
        <Route path="/" component={(props) => <ProtectedLayout {...props} user={user} roles={roles} />} />
      )}
      {isAuthenticated === false && (
        <Redirect
          to={{
            pathname: "/login",
            state: { from: location },
          }}
        />
      )}
    </Switch>
  );
}

export default Router;
// export default withAuthenticator(Router);
